import { Component } from "@angular/core"

import { EventService } from "../../services/event"

@Component({
  selector: "home-page",
  templateUrl: "index.html",
})
export class HomePage {

  eventsWaiting = []
  eventsExchange = []

  constructor(
    private eventService: EventService
  ) {

    this.eventsWaiting = this.eventService.getEventsWaitingConfirmation()
    this.eventsExchange = this.eventService.getEventExchanges()
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/index.ts